export function formatSalary(salary) {
    const num = Number(salary);
    if (!num || num === 0)
        return '—';
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
    }).format(num);
}
export function formatDate(dateString) {
    if (!dateString)
        return '—';
    const date = new Date(dateString);
    if (isNaN(date.getTime()))
        return 'Invalid Date';
    return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });
}
